import React, { Component } from 'react';
import {withTranslation} from 'react-i18next'
import { connect } from 'react-redux';
import { setGoHome } from '../action/homeAction';

class Loader extends Component{

    constructor(props) {
        super(props);
        this.state = {
            showCloseButton: false
        }
    }

    componentDidMount() {

        setTimeout(() => {
            this.setState({showCloseButton: true})
        }, 12000)
    }

    render(){
        const {t} = this.props
        return(
            <section class={`overlay loader ${this.props.loaderAdditionalHtmlClass}`}>
                <div class="overlay-window-container">
                    <div class="overlay-window no-bg loading">
                        <div class="overlay-content">
                            <div class="header">
                                <div class="header-icon">
                                    <i class="fas fa-ellipsis-h"></i>
                                    <p style={{fontSize: '1.25rem'}}>{this.props.displayMsg ? this.props.displayMsg : t('loader.fetching_data')}</p>
                                </div>
                                <div class="header-text">
                                    <div class="loader-ring">
                                        <img src="layout_2/assests/loader.png" />
                                    </div>
                                </div>
                                <div class="overlay-controls">
                                    { this.state.showCloseButton && <button class="button" onClick={()=>{ 
                                        if(this.props.close) this.props.close()
                                        else { this.props.setGoHome(true);}
                                        }}>{this.props.closeButtonTexts ? `${this.props.closeButtonTexts}` : 'Close'}</button>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}
const mapStateToProps=(state)=>{
    return {
        loaderAdditionalHtmlClass: state.store2.loaderAdditionalHtmlClass,
    }
}
export default connect(mapStateToProps,{setGoHome})(withTranslation('translations')(Loader));